export const API_VERSION = '1'
export const API_SEGMENT = '/branding/api'
